/** @jsxImportSource @emotion/react */
import {MouseEvent, useState, useEffect, FormEvent} from "react";
import { useNavigate } from "react-router-dom";
import { UploadFile, baseFrontAppUrl } from "../../common/Util";
import { ApiUrl, RouterUrl } from "../../common/Params";
import { ReactJSXElement } from "@emotion/react/types/jsx-namespace";
import { IconButton, Tooltip, Alert, Snackbar } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Snack } from "./Snack";
import configcss from "../../css/config.module.css";
import { PasswordDialog } from "./PasswordDialog";
import { ResultMessage, CompleteParam } from "../pages/ResultMessage";

export type BaseInfoProps = {
    siteId: string,
    siteName: string,
    logoutListner: (e: FormEvent) => Promise<void>,
}

export const BaseInfo = (prop: BaseInfoProps): ReactJSXElement => {

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
    //const navigate = useNavigate();

    async function downloadData(e: MouseEvent<HTMLInputElement, globalThis.MouseEvent>) {
        await UploadFile<Blob>(
            ApiUrl.DownloadUsageData,
            {},
            setIsLoading,
            "blob"
        ).then((response) => {
            const link = document.createElement("a");
            link.href = URL.createObjectURL(response.data);
            const dateObj = new Date();
            const datestr = dateObj.toLocaleDateString("ja-JP", {year: "numeric",month: "2-digit", day: "2-digit"}).replaceAll('/', '') + '-' + dateObj.toLocaleTimeString().replaceAll(':', '');
            link.setAttribute("download", `利用状況_${datestr}.txt`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        });
    }

    async function copyUrl(e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) {
        await global.navigator.clipboard.writeText(`${baseFrontAppUrl}/product${RouterUrl.Main}?siteid=${prop.siteId}`);
        setOpen(true);
    }

    function onCloseDialog() {
        
    }

    function onSuccessDialog(param: CompleteParam) {
        //navigate(RouterUrl.ResultMessage, {state: param});
    }

    useEffect(() => {
    }, [])

    return(
        <>
        <div className={`${configcss['infoBox']} ${configcss['config-header']}`}>
            <h2>基本情報</h2>
            <div className={`${configcss['logoutBox']}`}>
                <input type="button" value="パスワード変更" className={configcss['infoBoxBtn']} onClick={(e) => {
                    setIsDialogOpen((value) => { return true })
                }}></input>
                <input type="button" value="ログアウト" className={`${configcss['infoBoxBtn']}`}
                    onClick={prop.logoutListner}
                ></input>                
            </div>            
            <div className={`${configcss['infoBoxInner']} ${configcss['mdlBox']}`}>
                <p>
                    <span className={configcss['name']}>サイトID</span><span className={configcss['text']}>{prop.siteId}</span>
                </p>
                <p>
                    <span className={configcss['name']}>サイトURL</span><span className={configcss['text']}><a href={`${baseFrontAppUrl}/product${RouterUrl.Main}?siteid=${prop.siteId}`} target="_blank">{`${baseFrontAppUrl}/product${RouterUrl.Main}?siteid=${prop.siteId}`}</a>
                        <Tooltip title="クリップボードにコピー" placement="top" arrow>
                            <IconButton onClick={(e) => {copyUrl(e)}}>
                                <ContentCopyIcon fontSize="small"></ContentCopyIcon>
                            </IconButton>
                        </Tooltip>
                    </span>
                </p>                
                <p>
                    <input type="button" disabled={isLoading} value="利用状況データのダウンロード" onClick={(e) => {downloadData(e)}} className={configcss['infoBoxBtn']}/>
                </p>                
                </div>
            </div>
            <PasswordDialog
                isOpen={isDialogOpen}
                setIsOpen={setIsDialogOpen}
                onClose={onCloseDialog}
                onSuccess={onSuccessDialog}
            ></PasswordDialog>
        <Snack open={open} setOpen={setOpen} duration={6000} message="コピーしました" color="success" anchor={{vertical: "top", horizontal: "right"}} ></Snack>
        </>
    );
}